// extracted by mini-css-extract-plugin
export default {"percentageBar":"Percentage_percentageBar__jmiz9","bar-animation":"Percentage_bar-animation__N6vpX"};